import axios from './axiosInstance';
import { APIResort } from '../../types';

// Terrain-park writes (ullr-139 Phase 5). Route param is `:parkId` but the value
// passed is the AREA id (existing backend convention), so the path is
// `/${sport}/areas/${areaId}/terrainparks[/${terrainParkId}]` — areaId + sport in
// path, matching every other manage entity.
//
// ⚠ create/update/archive all return the RESORT object (with its terrain parks),
// NOT the terrain-park entity. Callers must therefore `refreshTerrainParks()`
// after a successful write to pick up the new/updated park.

interface SportAreaParams {
  sport: string;
  areaId: string;
}

interface CreateTerrainParkParams extends SportAreaParams {
  name: string;
  /** Stringified GeoJSON FeatureCollection (Polygon features). */
  geojson?: string;
  size?: string[];
}

interface UpdateTerrainParkParams extends SportAreaParams {
  terrainParkId: string;
  name?: string;
  /** Stringified GeoJSON FeatureCollection (Polygon features). */
  geojson?: string;
  size?: string[];
}

interface ArchiveTerrainParkParams extends SportAreaParams {
  terrainParkId: string;
}

// PUT — create. Returns the RESORT (not the park) → caller refreshes parks.
const createTerrainPark = ({ sport, areaId, name, geojson, size }: CreateTerrainParkParams): Promise<APIResort> => {
  const url = `/${sport}/areas/${areaId}/terrainparks`;
  return axios.put(url, {
    name,
    geojson,
    size,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

// POST — update. Returns the RESORT (not the park) → caller refreshes parks.
const updateTerrainPark = ({ sport, areaId, terrainParkId, name, geojson, size }: UpdateTerrainParkParams): Promise<APIResort> => {
  const url = `/${sport}/areas/${areaId}/terrainparks/${terrainParkId}`;
  return axios.post(url, {
    name,
    geojson,
    size,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

// DELETE — archive. Returns the RESORT (not the park) → caller refreshes parks.
const archiveTerrainPark = ({ sport, areaId, terrainParkId }: ArchiveTerrainParkParams): Promise<APIResort> => {
  const url = `/${sport}/areas/${areaId}/terrainparks/${terrainParkId}`;
  return axios.delete(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const terrainParkFunctions = {
  createTerrainPark,
  updateTerrainPark,
  archiveTerrainPark,
};

export default terrainParkFunctions;
